import { RefObject, useCallback, useRef } from "react";

export const useScrollTo = (
  options?: ScrollToOptions,
): [RefObject<HTMLElement>, Function] => {
  const scrollableContainer = useRef<HTMLElement>(null);

  const handleScroll = useCallback(() => {
    if (
      scrollableContainer?.current &&
      scrollableContainer.current.scrollTo // this line is specifically to work around an issue in JSDOM where scroll methods are not available, see: https://github.com/jsdom/jsdom/issues/1422
    ) {
      scrollableContainer.current.scrollTo({
        behavior: "smooth",
        top: 0,
        ...options,
      });
    }
  }, [scrollableContainer, options]);

  return [scrollableContainer, handleScroll];
};
